import { render, staticRenderFns } from "./DeviceDetailsReviewSkeleton.vue?vue&type=template&id=c263ca44&"
import script from "./DeviceDetailsReviewSkeleton.vue?vue&type=script&lang=js&"
export * from "./DeviceDetailsReviewSkeleton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/0/37556953/myshop/myshop/myshop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c263ca44')) {
      api.createRecord('c263ca44', component.options)
    } else {
      api.reload('c263ca44', component.options)
    }
    module.hot.accept("./DeviceDetailsReviewSkeleton.vue?vue&type=template&id=c263ca44&", function () {
      api.rerender('c263ca44', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/WEB-INF/views/fmfmo/common/devicereviews/DeviceDetailsReviewSkeleton.vue"
export default component.exports